export const coloresFestivos = {
  1: "#FF5733", // Nacional - Rojo Naranja
  2: "#3498DB", // Autonómico - Azul
  3: "#2ECC71", // Local - Verde
  4: "#9B59B6",
  5: "#F1C40F", // Otro - Amarillo
  // 5: "#9B59B6", // Extra (por si agregan más tipos en el futuro) - Morado
};

/**
 * Devuelve el color correspondiente a un tipo de festivo.
 * Si el tipo no existe, devuelve un color por defecto.
 *
 * @param {number} tipoFestivo - Tipo de festivo (1 = Nacional, 2 = Autonómico, etc.).
 * @param {string} [defaultColor='red'] - Color por defecto si el tipoFestivo no está definido.
 * @returns {string} - Código de color hexadecimal.
 */
export const obtenerColorFestivo = (tipoFestivo, defaultColor = "purple") => {
  // console.log(tipoFestivo);
  // console.log(coloresFestivos[tipoFestivo]); // undefined

  return coloresFestivos[tipoFestivo] || defaultColor;
};

export const esColorOscuro = (hex) => {
  if (!hex || typeof hex !== "string") return false;
  const color = hex.replace("#", "");
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);
  // luminancia perceptual
  const luminancia = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminancia < 150;
};
export const colorPermiso = "#AED6F1"; // celeste claro, o el que prefieras
